import React, { useState, useEffect } from 'react';
import '../App.css'

import { HomeDataContext } from "../contexts/HomeDataContext";
import { homeDataService } from "../services/HomeDataService";
function LoadingOverlay() {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="loading-spinner w-12 h-12 rounded-full border-t-4 border-blue-500 animate-spin"></div>
    </div>
  );
}

var url = process.env.REACT_APP_URL || "http://localhost:8080/";
function Agreements() {
  // State to hold form data
  const [formData, setFormData] = useState({
    addressee: '',
    name_of_addressee: '',
    date: '',
    offer_number: '',
    email: '',
    category: 'experience',
    basicOffer: null,
    standardOffer: null,
    premiumOffer: null,
    language: 'English' // Default language
  });

  const [agreements, setAgreements] = useState([]);

  const [loading, setLoading] = useState(false);

  const fetchAgreements = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${url}api/reports/agreements/all`);
      const data = await response.json();
      setAgreements(data);
    } catch (error) {
      console.error('Error fetching agreements:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgreements();
  }, []);

  // Update text and radio input fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  // Update file inputs
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: files[0] }));
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    const formDataToSubmit = new FormData();
    Object.keys(formData).forEach(key => {
      formDataToSubmit.append(key, formData[key]);
    });

    try {
      const response = await fetch(`${url}api/reports/agreements/create`, {
        method: 'POST',
        body: formDataToSubmit
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const url2 = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url2;
      link.setAttribute('download', 'generated.pdf'); // Set the file name
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Fetch the updated list of agreements
      fetchAgreements();
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to submit form.');
    }
  };



  return (
    <div className="p-8 bg-gray-100 rounded-lg shadow-lg">
    <form className="space-y-6 bg-white p-6 rounded-lg shadow-md" onSubmit={handleSubmit}>
      {/* Text inputs for basic form data */}

      <div className="flex justify-center">

        <h1 className='h1'>Create new offer</h1>
      </div>
      <div>
        <label htmlFor="addressee" className="block text-sm font-medium text-gray-700">Addressee</label>
        <input type="text" name="addressee" id="addressee" value={formData.addressee} onChange={handleInputChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"/>
      </div>
      <div>
        <label htmlFor="name_of_addressee" className="block text-sm font-medium text-gray-700">Name of Addressee</label>
        <input type="text" name="name_of_addressee" id="name_of_addressee" value={formData.name_of_addressee} onChange={handleInputChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"/>
      </div>
      <div>
        <label htmlFor="date" className="block text-sm font-medium text-gray-700">Date</label>
        <input type="date" name="date" id="date" value={formData.date} onChange={handleInputChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"/>
      </div>
      <div>
        <label htmlFor="offer_number" className="block text-sm font-medium text-gray-700">Offer Number</label>
        <input type="text" name="offer_number" id="offer_number" value={formData.offer_number} onChange={handleInputChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"/>
      </div>
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
        <input type="email" name="email" id="email" value={formData.email} onChange={handleInputChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"/>
      </div>
  
      {/* File inputs for uploading PDF offers */}
      
      <div>
        <label htmlFor="basicOffer" className="block text-sm font-medium text-gray-700">Basic Offer (PDF)</label>
        <input type="file" name="basicOffer" id="basicOffer" onChange={handleFileChange} className="mt-1 block w-full text-sm text-gray-900 border border-gray-300 rounded-md"/>
      </div>
      <div>
        <label htmlFor="standardOffer" className="block text-sm font-medium text-gray-700">Standard Offer (PDF)</label>
        <input type="file" name="standardOffer" id="standardOffer" onChange={handleFileChange} className="mt-1 block w-full text-sm text-gray-900 border border-gray-300 rounded-md"/>
      </div>
      <div>
        <label htmlFor="premiumOffer" className="block text-sm font-medium text-gray-700">Premium Offer (PDF)</label>
        <input type="file" name="premiumOffer" id="premiumOffer" onChange={handleFileChange} className="mt-1 block w-full text-sm text-gray-900 border border-gray-300 rounded-md"/>
      </div>
  
      {/* Radio buttons for category and language selection */}
      <div className="flex gap-4">
        <label className="flex items-center">
          <input type="radio" name="category" value="experience" checked={formData.category === 'experience'} onChange={handleInputChange} className="form-radio h-4 w-4 text-blue-600 border-gray-300" />
          <span className="ml-2">Experience</span>
        </label>
        <label className="flex items-center">
          <input type="radio" name="category" value="general" checked={formData.category === 'general'} onChange={handleInputChange} className="form-radio h-4 w-4 text-blue-600 border-gray-300" />
          <span className="ml-2">General</span>
        </label>
      </div>
      <div className="flex gap-4">
        <label className="flex items-center">
          <input type="radio" name="language" value="English" checked={formData.language === 'English'} onChange={handleInputChange} className="form-radio h-4 w-4 text-blue-600 border-gray-300" />
          <span className="ml-2">English</span>
        </label>
        <label className="flex items-center">
          <input type="radio" name="language" value="Slovenian" checked={formData.language === 'Slovenian'} onChange={handleInputChange} className="form-radio h-4 w-4 text-blue-600 border-gray-300" />
          <span className="ml-2">Slovenian</span>
        </label>
      </div>
  
      {/* Submit button */} <div className="flex justify-center">
      <button type="submit" className=" px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 w-[10%]">Submit</button>
    </div>
    </form>
  
    <div className="mt-8">
      <h2 className="text-2xl font-bold">Agreements</h2>
      {loading ? (
        <LoadingOverlay />
      ) : (
        <ul className="mt-4 space-y-4">
          {agreements.map(agreement => (
            <li key={agreement._id} className="mb-2 p-4 border border-gray-200 rounded-md bg-white shadow-sm">
              <p><strong>Addressee:</strong> {agreement.addressee}</p>
              <p><strong>Offer Number:</strong> {agreement.offer_number}</p>
              <p><strong>Email:</strong> {agreement.email}</p>
              <p><strong>Category:</strong> {agreement.category}</p>
              <p><strong>Language:</strong> {agreement.language}</p>
              <p><strong>Link:</strong> {agreement.link}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
  );
}


export default Agreements;